[
{
    "code": "EUR",
    "description": "Euro",
    "suggested": true,
    "symbol": "€",
    "locale": "nl-NL"
  },
  {
    "code": "GBP",
    "description": "British Pound Sterling",
    "suggested": true,
    "symbol": "£",
    "locale": "en-GB"
  },
  {
    "code": "USD",
    "description": "United States Dollar",
    "suggested": true,
    "symbol": "$",
    "locale": "en-US"
  },
  {
    "code": "AUD",
    "description": "Australian Dollar",
    "suggested": true,
    "symbol": "$",
    "locale": "en-AU"
  },
  {
    "code": "CAD",
    "description": "Canadian Dollar",
    "suggested": true,
    "symbol": "$",
    "locale": "en-CA"
  },
  {
    "code": "CNY",
    "description": "Chinese Yuan",
    "suggested": true,
    "symbol": "¥",
    "locale": "zh-CN"
  },
  {
    "code": "ZAR",
    "description": "South African Rand",
    "suggested": true,
    "symbol": "R",
    "locale": "en-ZA"
  },
  {
    "code": "JPY",
    "description": "Japanese Yen",
    "suggested": true,
    "symbol": "¥",
    "locale": "ja-JP"
  },
  {
    "code": "AED",
    "description": "United Arab Emirates Dirham",
    "suggested": false,
    "symbol": "د.إ",
    "locale": "ar-AE"
  },
  {
    "code": "AFN",
    "description": "Afghan Afghani",
    "suggested": false,
    "locale": "fa-AF"
  },
  {
    "code": "ALL",
    "description": "Albanian Lek",
    "suggested": false,
    "locale": "sq-AL"
  },
  {
    "code": "AMD",
    "description": "Armenian Dram",
    "suggested": false,
    "symbol": "AMD",
    "locale": "hy-AM"
  },
  {
    "code": "ANG",
    "description": "Netherlands Antillean Guilder",
    "suggested": false,
    "locale": "nl-CW"
  },
  {
    "code": "AOA",
    "description": "Angolan Kwanza",
    "suggested": false,
    "locale": "pt-AO"
  },
  {
    "code": "ARS",
    "description": "Argentine Peso",
    "suggested": false,
    "symbol": "$",
    "locale": "es-AR"
  },
  {
    "code": "AWG",
    "description": "Aruban Florin",
    "suggested": false,
    "locale": "nl-AW"
  },
  {
    "code": "AZN",
    "description": "Azerbaijani Manat",
    "suggested": false,
    "locale": "az-AZ"
  },
  {
    "code": "BAM",
    "description": "Bosnia-Herzegovina Convertible Mark",
    "suggested": false,
    "symbol": "KM",
    "locale": "bs-BA"
  },
  {
    "code": "BBD",
    "description": "Barbadian Dollar",
    "suggested": false,
    "symbol": "$",
    "locale": "en-BB"
  },
  {
    "code": "BDT",
    "description": "Bangladeshi Taka",
    "suggested": false,
    "symbol": "Tk",
    "locale": "bn-BD"
  },
  {
    "code": "BGN",
    "description": "Bulgarian Lev",
    "suggested": false,
    "symbol": "лв",
    "locale": "bg-BG"
  },
  {
    "code": "BHD",
    "description": "Bahraini Dinar",
    "suggested": false,
    "symbol": ".د.ب",
    "locale": "ar-BH"
  },
  {
    "code": "BIF",
    "description": "Burundian Franc",
    "suggested": false,
    "locale": "fr-BI"
  },
  {
    "code": "BMD",
    "description": "Bermudan Dollar",
    "suggested": false,
    "locale": "en-BM"
  },
  {
    "code": "BND",
    "description": "Brunei Dollar",
    "suggested": false,
    "locale": "ms-BN"
  },
  {
    "code": "BOB",
    "description": "Bolivian Boliviano",
    "suggested": false,
    "locale": "es-BO"
  },
  {
    "code": "BRL",
    "description": "Brazilian Real",
    "suggested": false,
    "symbol": "R$",
    "locale": "pt-BR"
  },
  {
    "code": "BSD",
    "description": "Bahamian Dollar",
    "suggested": false,
    "locale": "en-BS"
  },
  {
    "code": "BTC",
    "description": "Bitcoin",
    "suggested": false,
    "locale": "en-US"
  },
  {
    "code": "BTN",
    "description": "Bhutanese Ngultrum",
    "suggested": false,
    "locale": "dz-BT"
  },
  {
    "code": "BWP",
    "description": "Botswanan Pula",
    "suggested": false,
    "locale": "en-BW"
  },
  {
    "code": "BYN",
    "description": "Belarusian Ruble",
    "suggested": false,
    "symbol": "Br",
    "locale": "be-BY"
  },
  {
    "code": "BZD",
    "description": "Belize Dollar",
    "suggested": false,
    "locale": "en-BZ"
  },
  {
    "code": "CDF",
    "description": "Congolese Franc",
    "suggested": false
  },
  {
    "code": "CHF",
    "description": "Swiss Franc",
    "suggested": false,
    "symbol": "CHF",
    "locale": "de-CH"
  },
  {
    "code": "CLF",
    "description": "Chilean Unit of Account (UF)",
    "suggested": false
  },
  {
    "code": "CLP",
    "description": "Chilean Peso",
    "suggested": false,
    "symbol": "$"
  },
  {
    "code": "CNH",
    "description": "Chinese Yuan (Offshore)",
    "suggested": false
  },
  {
    "code": "COP",
    "description": "Colombian Peso",
    "suggested": false,
    "symbol": "$"
  },
  {
    "code": "CRC",
    "description": "Costa Rican Colón",
    "suggested": false,
    "symbol": "₡"
  },
  {
    "code": "CUC",
    "description": "Cuban Convertible Peso",
    "suggested": false
  },
  {
    "code": "CUP",
    "description": "Cuban Peso",
    "suggested": false
  },
  {
    "code": "CVE",
    "description": "Cape Verdean Escudo",
    "suggested": false
  },
  {
    "code": "CZK",
    "description": "Czech Republic Koruna",
    "suggested": false,
    "symbol": "Kč",
    "locale": "cs-CZ"
  },
  {
    "code": "DJF",
    "description": "Djiboutian Franc",
    "suggested": false
  },
  {
    "code": "DKK",
    "description": "Danish Krone",
    "suggested": false,
    "symbol": "kr",
    "locale": "da-DK"
  },
  {
    "code": "DOP",
    "description": "Dominican Peso",
    "suggested": false,
    "symbol": "RD$"
  },
  {
    "code": "DZD",
    "description": "Algerian Dinar",
    "suggested": false,
    "symbol": "DA"
  },
  {
    "code": "EGP",
    "description": "Egyptian Pound",
    "suggested": false,
    "symbol": "E£"
  },
  {
    "code": "ERN",
    "description": "Eritrean Nakfa",
    "suggested": false
  },
  {
    "code": "ETB",
    "description": "Ethiopian Birr",
    "suggested": false,
    "symbol": "Br"
  },
  {
    "code": "FJD",
    "description": "Fijian Dollar",
    "suggested": false
  },
  {
    "code": "FKP",
    "description": "Falkland Islands Pound",
    "suggested": false
  },
  {
    "code": "GEL",
    "description": "Georgian Lari",
    "suggested": false,
    "symbol": "GEL"
  },
  {
    "code": "GGP",
    "description": "Guernsey Pound",
    "suggested": false
  },
  {
    "code": "GHS",
    "description": "Ghanaian Cedi",
    "suggested": false,
    "symbol": "GH₵"
  },
  {
    "code": "GIP",
    "description": "Gibraltar Pound",
    "suggested": false
  },
  {
    "code": "GMD",
    "description": "Gambian Dalasi",
    "suggested": false
  },
  {
    "code": "GNF",
    "description": "Guinean Franc",
    "suggested": false
  },
  {
    "code": "GTQ",
    "description": "Guatemalan Quetzal",
    "suggested": false,
    "symbol": "Q"
  },
  {
    "code": "GYD",
    "description": "Guyanaese Dollar",
    "suggested": false
  },
  {
    "code": "HKD",
    "description": "Hong Kong Dollar",
    "suggested": false,
    "symbol": "HK$",
    "locale": "zh-HK"
  },
  {
    "code": "HNL",
    "description": "Honduran Lempira",
    "suggested": false,
    "symbol": "L"
  },
  {
    "code": "HRK",
    "description": "Croatian Kuna",
    "suggested": false,
    "symbol": "kn"
  },
  {
    "code": "HTG",
    "description": "Haitian Gourde",
    "suggested": false
  },
  {
    "code": "HUF",
    "description": "Hungarian Forint",
    "suggested": false,
    "symbol": "Ft",
    "locale": "hu-HU"
  },
  {
    "code": "IDR",
    "description": "Indonesian Rupiah",
    "suggested": false,
    "symbol": "Rp",
    "locale": "id-ID"
  },
  {
    "code": "ILS",
    "description": "Israeli New Sheqel",
    "suggested": false,
    "symbol": "₪",
    "locale": "he-IL"
  },
  {
    "code": "IMP",
    "description": "Manx pound",
    "suggested": false
  },
  {
    "code": "INR",
    "description": "Indian Rupee",
    "suggested": false,
    "symbol": "₹",
    "locale": "hi-IN"
  },
  {
    "code": "IQD",
    "description": "Iraqi Dinar",
    "suggested": false
  },
  {
    "code": "IRR",
    "description": "Iranian Rial",
    "suggested": false
  },
  {
    "code": "ISK",
    "description": "Icelandic Króna",
    "suggested": false,
    "symbol": "Íkr"
  },
  {
    "code": "JEP",
    "description": "Jersey Pound",
    "suggested": false
  },
  {
    "code": "JMD",
    "description": "Jamaican Dollar",
    "suggested": false,
    "symbol": "J$"
  },
  {
    "code": "JOD",
    "description": "Jordanian Dinar",
    "suggested": false,
    "symbol": "د.أ"
  },
  {
    "code": "KES",
    "description": "Kenyan Shilling",
    "suggested": false,
    "symbol": "KSh"
  },
  {
    "code": "KGS",
    "description": "Kyrgystani Som",
    "suggested": false,
    "symbol": "лв"
  },
  {
    "code": "KHR",
    "description": "Cambodian Riel",
    "suggested": false
  },
  {
    "code": "KMF",
    "description": "Comorian Franc",
    "suggested": false
  },
  {
    "code": "KPW",
    "description": "North Korean Won",
    "suggested": false
  },
  {
    "code": "KRW",
    "description": "South Korean Won",
    "suggested": false,
    "symbol": "₩",
    "locale": "ko-KR"
  },
  {
    "code": "KWD",
    "description": "Kuwaiti Dinar",
    "suggested": false,
    "symbol": "د.ك"
  },
  {
    "code": "KYD",
    "description": "Cayman Islands Dollar",
    "suggested": false
  },
  {
    "code": "KZT",
    "description": "Kazakhstani Tenge",
    "suggested": false,
    "symbol": "₸"
  },
  {
    "code": "LAK",
    "description": "Laotian Kip",
    "suggested": false
  },
  {
    "code": "LBP",
    "description": "Lebanese Pound",
    "suggested": false
  },
  {
    "code": "LKR",
    "description": "Sri Lankan Rupee",
    "suggested": false,
    "symbol": "₨"
  },
  {
    "code": "LRD",
    "description": "Liberian Dollar",
    "suggested": false
  },
  {
    "code": "LSL",
    "description": "Lesotho Loti",
    "suggested": false
  },
  {
    "code": "LYD",
    "description": "Libyan Dinar",
    "suggested": false
  },
  {
    "code": "MAD",
    "description": "Moroccan Dirham",
    "suggested": false,
    "symbol": "DH"
  },
  {
    "code": "MDL",
    "description": "Moldovan Leu",
    "suggested": false,
    "symbol": "L"
  },
  {
    "code": "MGA",
    "description": "Malagasy Ariary",
    "suggested": false
  },
  {
    "code": "MKD",
    "description": "Macedonian Denar",
    "suggested": false,
    "symbol": "ден"
  },
  {
    "code": "MMK",
    "description": "Myanma Kyat",
    "suggested": false,
    "symbol": "K"
  },
  {
    "code": "MNT",
    "description": "Mongolian Tugrik",
    "suggested": false
  },
  {
    "code": "MOP",
    "description": "Macanese Pataca",
    "suggested": false
  },
  {
    "code": "MRU",
    "description": "Mauritanian Ouguiya",
    "suggested": false
  },
  {
    "code": "MUR",
    "description": "Mauritian Rupee",
    "suggested": false,
    "symbol": "₨"
  },
  {
    "code": "MVR",
    "description": "Maldivian Rufiyaa",
    "suggested": false
  },
  {
    "code": "MWK",
    "description": "Malawian Kwacha",
    "suggested": false
  },
  {
    "code": "MXN",
    "description": "Mexican Peso",
    "suggested": false,
    "symbol": "$",
    "locale": "es-MX"
  },
  {
    "code": "MYR",
    "description": "Malaysian Ringgit",
    "suggested": false,
    "symbol": "RM",
    "locale": "ms-MY"
  },
  {
    "code": "MZN",
    "description": "Mozambican Metical",
    "suggested": false
  },
  {
    "code": "NAD",
    "description": "Namibian Dollar",
    "suggested": false
  },
  {
    "code": "NGN",
    "description": "Nigerian Naira",
    "suggested": false,
    "symbol": "₦"
  },
  {
    "code": "NIO",
    "description": "Nicaraguan Córdoba",
    "suggested": false
  },
  {
    "code": "NOK",
    "description": "Norwegian Krone",
    "suggested": false,
    "symbol": "kr",
    "locale": "nb-NO"
  },
  {
    "code": "NPR",
    "description": "Nepalese Rupee",
    "suggested": false,
    "symbol": "रु॰"
  },
  {
    "code": "NZD",
    "description": "New Zealand Dollar",
    "suggested": false,
    "symbol": "$",
    "locale": "en-NZ"
  },
  {
    "code": "OMR",
    "description": "Omani Rial",
    "suggested": false,
    "symbol": "ر.ع."
  },
  {
    "code": "PAB",
    "description": "Panamanian Balboa",
    "suggested": false,
    "symbol": "B/."
  },
  {
    "code": "PEN",
    "description": "Peruvian Nuevo Sol",
    "suggested": false,
    "symbol": "S/"
  },
  {
    "code": "PGK",
    "description": "Papua New Guinean Kina",
    "suggested": false
  },
  {
    "code": "PHP",
    "description": "Philippine Peso",
    "suggested": false,
    "symbol": "₱",
    "locale": "en-PH"
  },
  {
    "code": "PKR",
    "description": "Pakistani Rupee",
    "suggested": false,
    "symbol": "₨"
  },
  {
    "code": "PLN",
    "description": "Polish Zloty",
    "suggested": false,
    "symbol": "zł",
    "locale": "pl-PL"
  },
  {
    "code": "PYG",
    "description": "Paraguayan Guarani",
    "suggested": false,
    "symbol": "₲"
  },
  {
    "code": "QAR",
    "description": "Qatari Rial",
    "suggested": false,
    "symbol": "ر.ق"
  },
  {
    "code": "RON",
    "description": "Romanian Leu",
    "suggested": false,
    "symbol": "lei",
    "locale": "ro-RO"
  },
  {
    "code": "RSD",
    "description": "Serbian Dinar",
    "suggested": false,
    "symbol": "РСД"
  },
  {
    "code": "RUB",
    "description": "Russian Ruble",
    "suggested": false,
    "symbol": "₽",
    "locale": "ru-RU"
  },
  {
    "code": "RWF",
    "description": "Rwandan Franc",
    "suggested": false,
    "symbol": "FRw"
  },
  {
    "code": "SAR",
    "description": "Saudi Riyal",
    "suggested": false,
    "symbol": "ر.س"
  },
  {
    "code": "SBD",
    "description": "Solomon Islands Dollar",
    "suggested": false
  },
  {
    "code": "SCR",
    "description": "Seychellois Rupee",
    "suggested": false
  },
  {
    "code": "SDG",
    "description": "Sudanese Pound",
    "suggested": false
  },
  {
    "code": "SEK",
    "description": "Swedish Krona",
    "suggested": false,
    "symbol": "kr",
    "locale": "sv-SE"
  },
  {
    "code": "SGD",
    "description": "Singapore Dollar",
    "suggested": false,
    "symbol": "S$",
    "locale": "en-SG"
  },
  {
    "code": "SHP",
    "description": "Saint Helena Pound",
    "suggested": false
  },
  {
    "code": "SLL",
    "description": "Sierra Leonean Leone",
    "suggested": false
  },
  {
    "code": "SOS",
    "description": "Somali Shilling",
    "suggested": false
  },
  {
    "code": "SRD",
    "description": "Surinamese Dollar",
    "suggested": false
  },
  {
    "code": "SSP",
    "description": "South Sudanese Pound",
    "suggested": false
  },
  {
    "code": "STD",
    "description": "São Tomé and Príncipe Dobra (pre-2018)",
    "suggested": false
  },
  {
    "code": "STN",
    "description": "São Tomé and Príncipe Dobra",
    "suggested": false
  },
  {
    "code": "SVC",
    "description": "Salvadoran Colón",
    "suggested": false
  },
  {
    "code": "SYP",
    "description": "Syrian Pound",
    "suggested": false
  },
  {
    "code": "SZL",
    "description": "Swazi Lilangeni",
    "suggested": false
  },
  {
    "code": "THB",
    "description": "Thai Baht",
    "suggested": false,
    "symbol": "฿",
    "locale": "th-TH"
  },
  {
    "code": "TJS",
    "description": "Tajikistani Somoni",
    "suggested": false,
    "symbol": "TJS"
  },
  {
    "code": "TMT",
    "description": "Turkmenistani Manat",
    "suggested": false
  },
  {
    "code": "TND",
    "description": "Tunisian Dinar",
    "suggested": false,
    "symbol": "DT"
  },
  {
    "code": "TOP",
    "description": "Tongan Pa'anga",
    "suggested": false
  },
  {
    "code": "TRY",
    "description": "Turkish Lira",
    "suggested": false,
    "symbol": "₺",
    "locale": "tr-TR"
  },
  {
    "code": "TTD",
    "description": "Trinidad and Tobago Dollar",
    "suggested": false,
    "symbol": "TT$"
  },
  {
    "code": "TWD",
    "description": "New Taiwan Dollar",
    "suggested": false,
    "symbol": "NT$",
    "locale": "zh-TW"
  },
  {
    "code": "TZS",
    "description": "Tanzanian Shilling",
    "suggested": false,
    "symbol": "TSh"
  },
  {
    "code": "UAH",
    "description": "Ukrainian Hryvnia",
    "suggested": false,
    "symbol": "₴",
    "locale": "uk-UA"
  },
  {
    "code": "UGX",
    "description": "Ugandan Shilling",
    "suggested": false,
    "symbol": "USh"
  },
  {
    "code": "UYU",
    "description": "Uruguayan Peso",
    "suggested": false,
    "symbol": "$U"
  },
  {
    "code": "UZS",
    "description": "Uzbekistan Som",
    "suggested": false,
    "symbol": "лв"
  },
  {
    "code": "VEF",
    "description": "Venezuelan Bolívar Fuerte (Old)",
    "suggested": false
  },
  {
    "code": "VES",
    "description": "Venezuelan Bolívar Soberano",
    "suggested": false
  },
  {
    "code": "VND",
    "description": "Vietnamese Dong",
    "suggested": false,
    "symbol": "₫",
    "locale": "vi-VN"
  },
  {
    "code": "VUV",
    "description": "Vanuatu Vatu",
    "suggested": false
  },
  {
    "code": "WST",
    "description": "Samoan Tala",
    "suggested": false
  },
  {
    "code": "XAF",
    "description": "CFA Franc BEAC",
    "suggested": false
  },
  {
    "code": "XAG",
    "description": "Silver Ounce",
    "suggested": false
  },
  {
    "code": "XAU",
    "description": "Gold Ounce",
    "suggested": false
  },
  {
    "code": "XCD",
    "description": "East Caribbean Dollar",
    "suggested": false
  },
  {
    "code": "XDR",
    "description": "Special Drawing Rights",
    "suggested": false
  },
  {
    "code": "XOF",
    "description": "CFA Franc BCEAO",
    "suggested": false
  },
  {
    "code": "XPD",
    "description": "Palladium Ounce",
    "suggested": false
  },
  {
    "code": "XPF",
    "description": "CFP Franc",
    "suggested": false
  },
  {
    "code": "XPT",
    "description": "Platinum Ounce",
    "suggested": false
  },
  {
    "code": "YER",
    "description": "Yemeni Rial",
    "suggested": false,
    "locale": "ar-YE"
  },
  {
    "code": "ZMW",
    "description": "Zambian Kwacha",
    "suggested": false,
    "symbol": "K",
    "locale": "en-ZM"
  },
  {
    "code": "ZWL",
    "description": "Zimbabwean Dollar",
    "suggested": false,
    "locale": "en-ZW"
  }
]
